const data = {
  namespaced: true,
  state: {
    // 页面滚动位置
    scrollPosition: {
      'homePage': {
        name: 'homePage',
        to: 'homePage',
        scroll: 0
      }
    },
    menus: [],
  },
  mutations: {
    SetScrollPosition(state, position) {
      state.scrollPosition[position.name || 'homePage'] = position;
    },
    SetMenus(state, datas) {
      state.menus = datas;
    }
  },
  actions: {
    setScrollPosition({ commit }, position) {
      commit("SetScrollPosition", position);
    },
    setMenus({ commit }, datas) {
      commit("SetMenus", datas);
    },
  },
};

export default data;
